import { Pipe, PipeTransform } from '@angular/core';
import { PartBinLocationItem } from 'entities/part-bin-location-item';

@Pipe({ name: 'commareplace'})
export class CommaReplacePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/,/g, ', ').replace(/,  /g, ', ');
  }
}
